var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import DiscretelyTimeVaryingTraits from "./DiscretelyTimeVaryingTraits";
import ImageryProviderTraits from "./ImageryProviderTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import { MinMaxLevelTraits } from "./MinMaxLevelTraits";
import UrlTraits from "./UrlTraits";
let ArcGisMapServerCatalogItemTraits = (_dec = traitClass({
  description: "Creates a single item in the catalog from one or many ESRI WMS layers.\n\n  <strong>Note:</strong> <i>The following example does not specify <b>layers</b> property therefore will present all layers in the given URL as single catalog item. To present specific layers only, add them in <b>layers</b> property, e.g. <code>\"layers\": \"AUS_GA_2500k_MiscLines,AUS_GA_2500k_Faults\"</code>.</i>",
  example: {
    url: "https://services.ga.gov.au/gis/rest/services/GA_Surface_Geology/MapServer",
    type: "esri-mapServer",
    name: "Surface Geology"
  }
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Layer(s)",
  description: "The layer or layers to display. This can be a comma separated string of layer IDs or names."
}), _dec3 = primitiveTrait({
  type: "number",
  name: "Maximum scale",
  description: "Gets or sets the denominator of the largest scale (smallest denominator) for which tiles should be requested.  For example, if this value is 1000, then tiles representing a scale larger than 1:1000 (i.e. numerically smaller denominator, when zooming in closer) will not be requested.  Instead, tiles of the largest-available scale, as specified by this property, will be used and will simply get blurier as the user zooms in closer."
}), _dec4 = anyTrait({
  name: "Parameters",
  description: "Additional parameters to pass to the MapServer when requesting images."
}), _dec5 = primitiveTrait({
  name: "Token URL",
  description: "URL to use for fetching request tokens. Note this will override the token trait if both are set.",
  type: "string"
}), _dec6 = primitiveTrait({
  name: "Token",
  description: "Token to use for ArcGiS REST API requests (if not using tokenUrl)",
  type: "string"
}), _dec7 = primitiveTrait({
  type: "number",
  name: "Maximum Refresh Intervals",
  description: "The maximum number of discrete times that can be created by a single " + "date range when layer in time-enabled."
}), _dec8 = primitiveTrait({
  name: "Time Window Duration",
  description: "Specify a time window duration when querying a time-enabled layer. Will not query with time window for non-positive value",
  type: "number"
}), _dec9 = primitiveTrait({
  name: "Time Window Unit",
  description: "The time window unit for the `Time Window Duration`. Any units supported by `moment` module are valid, such as, `year`, `month`, `week`, `day`, `hour`, etc. Will not query time with window if the unit is invalid or undefined.",
  type: "string"
}), _dec0 = primitiveTrait({
  name: "Is Forward Time Window",
  description: "If true, the time window is forward from the current time. Otherwise backward. Default to forward window.",
  type: "boolean"
}), _dec1 = primitiveTrait({
  name: "Use Pre-Cached Tiles If Available",
  description: "If true, the server's pre-cached tiles are used if they are available. If false, then the MapServer export endpoint will be used. This will default to true if no specific layers are fetched (i.e. all layers are fetched). Otherwise, it will default to false. This will also default to false if parameters have been specified",
  type: "boolean"
}), _dec(_class = (_class2 = class ArcGisMapServerCatalogItemTraits extends mixTraits(ImageryProviderTraits, LayerOrderingTraits, UrlTraits, CatalogMemberTraits, LegendOwnerTraits, DiscretelyTimeVaryingTraits, MinMaxLevelTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "layers", _descriptor, this);
    _initializerDefineProperty(this, "maximumScale", _descriptor2, this);
    _initializerDefineProperty(this, "parameters", _descriptor3, this);
    _initializerDefineProperty(this, "tokenUrl", _descriptor4, this);
    _initializerDefineProperty(this, "token", _descriptor5, this);
    _initializerDefineProperty(this, "maxRefreshIntervals", _descriptor6, this);
    _initializerDefineProperty(this, "timeWindowDuration", _descriptor7, this);
    _initializerDefineProperty(this, "timeWindowUnit", _descriptor8, this);
    _initializerDefineProperty(this, "isForwardTimeWindow", _descriptor9, this);
    _initializerDefineProperty(this, "usePreCachedTilesIfAvailable", _descriptor0, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "layers", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "maximumScale", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "parameters", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "tokenUrl", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "token", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "maxRefreshIntervals", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10000;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "timeWindowDuration", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "timeWindowUnit", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "isForwardTimeWindow", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "usePreCachedTilesIfAvailable", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { ArcGisMapServerCatalogItemTraits as default };